import { BildungsangebotTerminDetail } from '../../model/bildungsangebot-termin-detail';

export function getLernformText(termin: BildungsangebotTerminDetail): string {
  if (isSonstigeLernform(termin.unterrichtsform.id) && termin.sonstigeUnterrichtsform) {
    return termin.sonstigeUnterrichtsform;
  }
  return termin.unterrichtsform.bezeichnung;
}

function isSonstigeLernform(id: number): boolean {
  return id === 105 || id === 206 || id === 304 || id === 403;
}
